import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitAppraisal = (payload) =>
  axios.post(`${API}/appraisal`, payload).then((r) => r.data);
export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);
export const submitTenant = (payload) =>
  axios.post(`${API}/tenant-request`, payload).then((r) => r.data);
export const submitPartner = (payload) =>
  axios.post(`${API}/partner-enquiry`, payload).then((r) => r.data);
